export default __webpack_public_path__ + "static/media/hero-03.05b7336d.jpg";